import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/shared/pageHeader/PageHeader";
import StandsListView from "../stands/list/view";
import _environment from "../../_environment/_environment";
import { ANALYTICS_EVENTS, trackAnalyticsEvent } from "../../utils/analytics";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
const ChatView = (props: any) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const openChatLink = () => {
    // Track event
    trackAnalyticsEvent(ANALYTICS_EVENTS.GENERAL_CHAT);

    window.open(`${_environment.mattermost.URL}/${_environment.mattermost.generalRoom}`, "_blank");
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    console.log("[ChatView] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    console.log("[ChatView] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className="container full-page">
        <div className="full-page-image">
          <img src="/assets/images/undraw/social.png"/>
        </div>
        <PageHeader title={t("pages.chat.title")}/>

        <div className="chat-list">
          <div className="box mb-5 chat-box">
            <div className="info">
              <h2>{t("pages.chat.boxes.general.title")}</h2>
              <p>{t("pages.chat.boxes.general.description")}</p>

              <div className="actions">
                <a
                  className="btn btn-warning btn-block btn-flex"
                  onClick={openChatLink}
                  rel="noopener noreferrer"
                >
                  Go to chat room <i className="fas fa-comments"></i>
                </a>
              </div>
            </div>
            <div className="image">
              <img src="/assets/images/alfredos.png"/>
            </div>
          </div>
          <div className="box mb-5 chat-box whatsapp">
            <div className="info">
              <h2>{t("pages.chat.boxes.whatsapp.title")}</h2>
              <p>{t("pages.chat.boxes.whatsapp.description")}</p>

              <div className="actions">
                <a
                  className="btn btn-whatsapp btn-outline btn-block btn-flex"
                  href={`tel:${_environment.whatsapp.number}`}
                  rel="noopener noreferrer"
                >
                  Contact us
                </a>
              </div>
            </div>
            <div className="image">
              <img src="/assets/images/help.png"/>
            </div>
          </div>
        </div>

        <StandsListView
          isChat={true}
          title={t("pages.chat.stands")}
          description={t("pages.chat.stands_description")}
          showBackgroundImage={false}
        />
      </div>
    </>
  );
};
export default ChatView;
